import ApiService from 'services/ApiService/ApiService';
import ConfigurationService, { ConfigurationKeys } from 'services/ConfigurationService';
import { resolveURLPath } from 'utils/urlHelpers';


export const fetchProfileInfo = async(username) => {
  const baseUrl = ConfigurationService.get(ConfigurationKeys.BASE_URL);
  const url = new URL(baseUrl);
  url.pathname = resolveURLPath(url.pathname, `rest/v1.0/profile/${username}/info`);

  const { data } = await ApiService.get(url);

  const { fanClubMigrationStatus, temptedFanClub } = data || {};
  const isMigrated = fanClubMigrationStatus === 'MIGRATED';
  const hasTemptedFanClub = Boolean(temptedFanClub) && fanClubMigrationStatus !== 'NOT_MIGRATED';

  const hasNewFanClub = hasTemptedFanClub || isMigrated;

  return { ...data, hasNewFanClub };
};
